export const STICKY_FILLER_CLASS = 'sticky-filler';
export const STICKY_HEADER_CLASS = 'sticky-header';
export const POST_STICKY_CLASS = 'post-sticky-header';

const addClass = (element: Element, className: string) => {
    if (!element.classList.contains(className)) {
        element.classList.add(className);
    }
};

const removeClass = (element: Element, className: string) => {
    if (element.classList.contains(className)) {
        element.classList.remove(className);
    }
};

export const syncScroll = (element?: Element) => (e: Event) => {
    if (element) {
        element.scrollLeft = (e.currentTarget as HTMLElement)?.scrollLeft;
    }
};

export const handleStickyScroll = (stickyPosition: number, ref: HTMLElement | null) => () => {
    const table = ref?.getElementsByTagName('table')[0];
    const tableHeader = ref?.getElementsByTagName('thead')[0];
    const tableContainer = ref?.getElementsByClassName('rt-table-container')[0];
    const stickyHeaderFiller = ref?.getElementsByClassName('sticky-header-filler')[0];

    if (!table || !tableContainer || !tableHeader || !stickyHeaderFiller) {
        return;
    }

    const { height: headerHeight, y: headerY } = tableHeader.getBoundingClientRect();
    const { height: tableHeight, y: tableY } = table.getBoundingClientRect();

    // Limit the width of the Header so it doesn't overflow offscreen
    tableHeader.style.width = tableContainer.getBoundingClientRect().width + 'px';

    // The Header will be in one of the three states.
    // 1. Pre Stick     Initial Position    Header is below the "sticky" position
    //                                      The Header hasn't reached the top of the screen
    // 2. Stick         Fixed Position      Header is at the "sticky" position and the Table is in view
    // 3. Post Stick    Absolute Position   Table and Header are above the "sticky" position

    const preStick = () => {
        removeClass(tableHeader, STICKY_HEADER_CLASS);
        removeClass(tableHeader, POST_STICKY_CLASS);
        removeClass(stickyHeaderFiller, STICKY_FILLER_CLASS);
        tableHeader.style.top = null;
    };

    const sticking = () => {
        addClass(tableHeader, STICKY_HEADER_CLASS);
        removeClass(tableHeader, POST_STICKY_CLASS);
        addClass(stickyHeaderFiller, STICKY_FILLER_CLASS);
        tableHeader.style.top = null;
    };

    const postStick = () => {
        removeClass(tableHeader, STICKY_HEADER_CLASS);
        addClass(tableHeader, POST_STICKY_CLASS);
        addClass(stickyHeaderFiller, STICKY_FILLER_CLASS);

        const tableBottomPosition = tableHeight + tableY;
        tableHeader.style.top = `${window.scrollY + tableBottomPosition - headerHeight}px`;
    };

    // When the header is not sticking the Table Y and Header Y position will be the same
    // When the header first sticks the Header will be at the "sticky" position. However since the Header's
    // position is fixed it's out of flow with the Table, which moves the Table Y position up.
    // We add in a filler which is the same height as the Header to prevent jumping when we scroll back up
    if (tableY <= stickyPosition + (tableY === headerY ? 0 : headerHeight)) {
        const headerBottomPosition = headerHeight + headerY;
        const tableBottomPosition = tableHeight + tableY;

        // If the Header's position was above the "sticky" position then comes back into view and scrolls past the
        // "sticky" position we make the Header stick again
        if (tableHeader.classList.contains(POST_STICKY_CLASS)) {
            if (headerY >= stickyPosition) {
                sticking();
            }
            return;
        }

        // If the Header has scrolled past the end of the Table, then we update the Header's position to absolute
        if (headerBottomPosition > tableBottomPosition) {
            postStick();
        } else {
            sticking();
        }
    } else if (tableY > headerHeight) {
        preStick();
    }
};
